import React from 'react';

import {createColors} from "color-map";

export const matrix = {
    'intro': {
        name: 'intro',
        limit: 1,
    },
    'body': {
        name: 'body',
        limit: 3,
    },
    'outro': {
        name: 'outro',
        limit: 1,
    },
    'total': 5,
};

export const speed = 300;

export function shuffle(array) {
    let counter = array.length, index, temp;
    while (counter > 0) {
        index = Math.floor(Math.random() * counter);    // picking a random index
        counter--;
        temp = array[counter];
        array[counter] = array[index];
        array[index] = temp;
    }
    return array;
}

export function generateRandomColor(currentApp, selectedTheme) {   // to generate different shades of colors
    // shades of blue
    let firstColorsSet = [[104, 84, 255, 1], [90, 68, 255, 1], [75, 51, 255, 1], [61, 35, 255, 1], [46, 18, 255, 1]];
    let secondColorsSet = [[220, 149, 223, 1], [219, 124, 223, 1], [217, 100, 224, 1], [216, 75, 224, 1], [214, 50, 224, 1]];
    let thirdColorsSet = [[122, 206, 245, 1], [117, 204, 245, 1], [111, 203, 245, 1], [106, 201, 245, 1], [100, 199, 245, 1]];
    let fourthColorsSet = [[195, 140, 250, 1], [184, 120, 249, 1], [174, 100, 248, 1], [163, 79, 246, 1], [152, 59, 245, 1]];
    let fifthColorsSet =  [[231, 18, 255, 1], [237, 18, 241, 1], [243, 18, 228, 1], [249, 18, 214, 1], [255, 18, 200, 1]];

    // shades of orange
    if (currentApp === 'app-2') {
        firstColorsSet = [[246, 127, 80, 1], [244, 130, 67, 1], [241, 133, 53, 1], [239, 135, 40, 1], [236, 138, 26, 1]];
        secondColorsSet = [[255, 99, 71, 1], [253, 121, 85, 1], [251, 143, 100, 1], [248, 165, 114, 1], [246, 187, 128, 1]];
        thirdColorsSet = [[255, 215, 0, 1], [252, 208, 14, 1], [249, 201, 27, 1], [246, 193, 41, 1], [243, 186, 54, 1]];
        fourthColorsSet = [[255, 140, 0, 1], [252, 158, 17, 1], [249, 177, 34, 1], [245, 195, 50, 1], [242, 213, 67, 1]];
        fifthColorsSet = [[255, 165, 0, 1], [254, 186, 13, 1], [252, 207, 27, 1], [251, 228, 40, 1], [240, 240, 100, 1]];
    }

    if (currentApp === 'app-3') {
        // shades of red
        if (selectedTheme === 'Reading') {
            firstColorsSet = createColors([255, 0, 0], [255, 140, 140], 5,);
            secondColorsSet = createColors([250, 0, 0], [250, 140, 140], 5,);
            thirdColorsSet = createColors([245, 0, 0], [245, 140, 140], 5,);
            fourthColorsSet = createColors([240, 0, 0], [240, 140, 140], 5,);
            fifthColorsSet = createColors([235, 0, 0], [235, 140, 140], 5,);
        }
        // shades of yellow
        if (selectedTheme === 'Vocabulary') {
            firstColorsSet = createColors([255, 145, 0], [255, 190, 100], 5,);
            secondColorsSet = createColors([250, 145, 0], [250, 190, 100], 5,);
            thirdColorsSet = createColors([245, 145, 0], [245, 190, 100], 5,);
            fourthColorsSet = createColors([240, 145, 0], [240, 190, 100], 5,);
            fifthColorsSet = createColors([235, 145, 0], [235, 190, 100], 5,);
        }
        // shades of purple
        if (selectedTheme === 'Grammar') {
            firstColorsSet = createColors([255, 100, 150], [255, 0, 111], 5,);
            secondColorsSet = createColors([245, 100, 150], [245, 0, 100], 5,);
            thirdColorsSet = createColors([235, 100, 150], [235, 0, 100], 5,);
            fourthColorsSet = createColors([225, 100, 150], [225, 0, 100], 5,);
            fifthColorsSet = createColors([215, 100, 150], [215, 0, 100], 5,);
        }
        // shades of blue
        if (selectedTheme === 'Comprehension') {
            firstColorsSet = createColors([120, 220, 255], [0, 190, 255], 5,);
            secondColorsSet = createColors([110, 188, 255], [0, 190, 245], 5,);
            thirdColorsSet = createColors([100, 188, 255], [0, 190, 235], 5,);
            fourthColorsSet = createColors([80, 188, 255], [0, 190, 225], 5,);
            fifthColorsSet = createColors([60, 188, 255], [0, 190, 215], 5,);
        }
    }

    // console.log('Color Set', fourthColorsSet)
    return shuffle([...firstColorsSet, ...secondColorsSet, ...thirdColorsSet, ...fourthColorsSet, ...fifthColorsSet]);
}

export function isActiveBlock(blocks, blockId) {    // this function checks is the block is active or not
    if (blocks.length !== 0) {  // if a block is selected, an array is passed
        return !!(blocks.find(block => block.id === blockId))
    } else return false;
}

export function isFlashingBlock(blocks, blockId) {
    if (blocks.length !== 0) {
        return !!(blocks.find(block => block.id === blockId && block.isFlashing))
    } else return false;
}


export function isBeforeAfterFlashingBlock(blocks, blockId) {   // need to check if this func really works and how does it work
    let isBeforeAfter = false;
    for (let i = 0; i < blocks.length; i++) {
        if (blocks[i].id === blockId) {
            let lastOneIndex = i - 1;
            if (lastOneIndex >= 0 && blocks[lastOneIndex].isFlashing) {
                isBeforeAfter = true;
            }
            let afterOneIndex = i + 1;
            if (afterOneIndex < blocks.length && blocks[afterOneIndex].isFlashing) {
                isBeforeAfter = true;
            }
        }
    }
    return isBeforeAfter;
}

export function getBlockIndex(blocks, blockId) {
    return blocks.findIndex(block => block.id === blockId);
}

export function sortBlocks(blocks, limit, block, threeBlocksSelected) {
    let otherBlocks = [], typeAlreadySelected;
    const introBlock = blocks.filter(block => block.type === 'intro');
    const outroBlock = blocks.filter(block => block.type === 'outro');

    if (block.type === 'intro') {
        otherBlocks = blocks.filter(bl => bl.type !== 'intro');
        typeAlreadySelected = blocks.find(bl => (bl.id !== block.id) && (bl.type === block.type));
        if (typeAlreadySelected) blocks.shift();
        if (otherBlocks.length > 0) return [block, ...otherBlocks];
        else return [block];
    }

    if (block.type === 'body') {
        let totalBodyBlocksSelected = blocks.filter(block => block.type === 'body');
        if (threeBlocksSelected) {
            totalBodyBlocksSelected.shift();
            totalBodyBlocksSelected.push(block);
        }
        if (introBlock.length > 0 && outroBlock.length > 0) {
            return [...introBlock, ...totalBodyBlocksSelected, ...outroBlock]
        } else if (introBlock.length > 0) {
            return [...introBlock, ...totalBodyBlocksSelected]
        } else if (outroBlock.length > 0) {
            return [...totalBodyBlocksSelected, ...outroBlock]
        } else return [...totalBodyBlocksSelected];
    }

    if (block.type === 'outro') {
        otherBlocks = blocks.filter(bl => bl.type !== 'outro');
        typeAlreadySelected = blocks.find(bl => (bl.id !== block.id) && (bl.type === block.type));
        if (typeAlreadySelected) blocks.pop();
        if (otherBlocks.length > 0) return [...otherBlocks, block];
        else return [block];
    }
}

export function resetFlashingBlocks(selectedBlocks, updateBlocks) {
    const resetBlocks = selectedBlocks.map(block => {
        block.isFlashing = false;
        return {...block};
    });
    updateBlocks(resetBlocks);
    return resetBlocks;
}


export function clearIntervalFlashing(clearFlashing) {
    clearFlashing && clearInterval(clearFlashing);
    clearFlashing = null;
    return clearFlashing;
}

export function stopAudio(audioRef) {
    audioRef.pause();
    audioRef.currentTime = 0;
}

export const matchSequence = (sequences, sequence, selectedBlocks) => {
    let matched = false, counter = 0;
    if (sequences.length > 0) {     // if we pass the whole sequence
        sequences.map(sequence => {
            counter = 0;
            selectedBlocks.map((selectedBlock, index) => { if (selectedBlock.id === sequence[index].id) counter++; return null });
            if (counter === 5) matched = true;
            return null;
        });
    } else {    // if only one sequence of blocks is passed
        selectedBlocks.map((selectedBlock, index) => { if (selectedBlock.id === sequence[index].id) counter++; return null });
        if (counter === 5) matched = true;
    }
     return matched;
};

const title = (
    <img src='/wp-content/plugins/terabit-matrix-game/assets/images/mylearningmyway-logo1.png'
         className='tooltip-logo'
         alt='MLMW_logo'
    />
);

export const steps = [      // for react-joyride (walkthrough tooltips)
    [
        {      // 1st element for app-1 -> 2nd, 3rd and 4th for app-2 -> 4th for app-3
        target: '.top-row-main',
        title,
        content: 'There are five columns: The first column is for the introduction, then columns two, three and four for the ideas and the last column is for the conclusion of the Talk.',
        placement: 'bottom',
        disableBeacon: true
    },
    {
        target: '.hamburger-menu',
        title,
        content: 'Please select a theme from this menu.',
        placement: 'bottom-end',
    },
    {
        target: '.intro-blocks-tooltip-container',
        title,
        content: 'Here\'s the column with 5 "Introductions". Select any one of them.',
        placement: 'right',
    },
    {
        target: '.body-blocks-tooltip-container',
        title,
        content: 'Here are the columns with the "Ideas". Select any three blocks from these columns.',
    },
    {
        target: '.outro-blocks-tooltip-container',
        title,
        content: 'Here\'s the column with 5 "Conclusions". Select any one of them.',
        placement: 'left',
    },
    {
        target: '.sequence-holder',
        title,
        content: 'This is where your sequences will be saved.',
        placement: 'left',
    },
    {
        target: '.script-button',
        title,
        content: 'Click here to see the scripts of your selected sequence (optional).',
    },
    {
        target: '.clear-button',
        title,
        content: 'Click here to stop playing the selected sequence.',
    },
    {
        target: '.clear-button',
        title,
        content: 'You can also clear the selected sequence by clicking on this button.',
    }],
    [{      // app-2 -> first step
        target: '.hamburger-menu',
        title,
        content: 'Please select a theme from this menu.',
        placement: 'bottom-start',
        disableBeacon: true
    }],
    [{      // app-2 -> second step
        target: '.tooltip-dots-container',
        title,
        content: 'You can listen to variations of opinion questions for each theme.',
        placement: 'left',
        disableBeacon: true
    }],
    [
    {      // app-2 -> next steps
        target: '.intro-blocks-tooltip-container',
        title,
        content: 'Here\'s the column with 5 "Introductions". Your intro is the key element that puts you on the road to level C (Abstract manner).Don\'t forget that the "Je" naturally puts you on the road to B (Concrete manner). \n' +
                    'The introduction is the general expression of opinion that you must provide at the very beginning of your response to demonstrate that you have understood the question and are meeting the assessors’ expectations.\n' +
                    'Select any one of them.',
        placement: 'right',
        disableBeacon: true
    },
    {
        target: '.body-blocks-tooltip-container',
        title,
        content: 'Here are the columns with the "Details, nuances" : You have to explain all the time and say why.\n' +
                    'Your message must be clear with concise vocabulary.\nSelect any three blocks from these columns.',
    },
    {
        target: '.outro-blocks-tooltip-container',
        title,
        content: 'Here\'s the column with 5 "Conclusions". Select any one of them.',
        placement: 'left',
    },
    {
        target: '.sequence-holder',
        title,
        content: 'This is where your sequences will be saved.',
        placement: 'left',
    },
    {
        target: '.script-button',
        title,
        content: 'Click here to see the scripts of your selected sequence (optional).',
    },
    {
        target: '.clear-button',
        title,
        content: 'Click here to stop playing the selected sequence.',
    },
    {
        target: '.clear-button',
        title,
        content: 'You can also clear the selected sequence by clicking on this button.',
    }],
    [{      // app-3 -> first step
        target: '.hamburger-menu',
        title,
        content: 'In order to better prepare yourself, you can choose in the menu to work only on one of the four skills: Reading / Vocabulary / Grammar / Comprehension\n',
        placement: 'bottom',
        disableBeacon: true
    },
    {
        target: '.slider-container',
        title,
        content: 'You can choose the speed at which the words appear (normal, slow or fast)',
        placement: 'bottom',
    }],
    [{      // app-3 -> next steps
        target: '.topic-list-container > .topic-title:first-child',
        title,
        content: 'Choose one of the 25 tiles and when you are ready the text will scroll. Then a question will appear with four choices of answers, click on the answer that you think is the best.\n' +
                     'Once finished, you can choose any other tile and continue.',
        placement: 'bottom',
        disableBeacon: true
    },
    {
        target: '.topicList-tooltip-container',
        title,
        content: 'For ’Grammar’ and ‘Vocabulary’, read the proposed text and answer the question by choosing the correct answer among the four possible answers.\n' +
                     'Once finished, you can open a new box.',
        placement: 'bottom',
    },
    {
        target: '.topic-list-container > .topic-title:last-child',
        title,
        content: 'Choose one of the 25 tiles and when you are ready the text will scroll. Then a question will appear with four choices of answers, click on the answer that you think is the best.\n' +
                     'Once finished, you can choose any other tile and continue.',
        placement: 'bottom',
    },
    {
        target: '.quiz-button',
        title,
        content: 'Quiz mode is a 25-question test. The 25 questions are a mix of reading, comprehension, vocabulary and grammar questions.',
        placement: 'bottom',
    },
    {
        target: '.quiz-button',
        title,
        content: 'To exit the quiz mode please click on END QUIZ MODE',
        placement: 'bottom',
    }]
];

export const cleanTheScript = script => {  // removes unnecessary space before the punctuation marks. This is what we have to do when the client is not careful with the data. smh
    /*
    ----- THE FOLLOWING FUNCTION IS TO CLEAN THE TEXT BUT THE CLIENT WANTS TO KEEP THE WAY THEY ARE -----
        ['.', ',', '!', '?'].map(mark => {
            const length = script.split(` ${mark}`).length - 1;
            script = script.split(` ${mark}`).map((word, index) => {
                if (index !== length) {
                    if (word.split('')[0] === ' ') return word += `${mark} `  // if there is space before current word
                    else return word += mark;
                } else return word;
            }).join('')
            return null;
        })
    */
    return script;
}

